import {assert} from 'Asserts';
import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import {EntityStoreUser} from 'constants/EntityStoreConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import EntityStore from 'stores/EntityStore';
import APIUtil from 'util/APIUtil';

export function getOrgIdsWithUserJoinRequest(): Array<string> {
  const currentUser: EntityStoreUser | null = EntityStore.currentUser();
  if (currentUser?.currentUserOutboundRequests) {
    return currentUser.currentUserOutboundRequests.map(
      // @ts-expect-error When converting this file to ts, we found this type error.
      (orgRequest) => orgRequest.organizationId
    );
  }
  return [];
}

export function hasSentRequestForOrg(orgId: string): boolean {
  const requestedToJoinOrgs = getOrgIdsWithUserJoinRequest();
  return requestedToJoinOrgs.includes(orgId);
}

export function isTeam(entityId: string): boolean {
  const type = APIUtil.apiIdToType(entityId);
  switch (type) {
    case ModelTypeConstants.TEAM:
      return true;
    default:
      assert(type === ModelTypeConstants.ENTITY, `Unexpected entity id: ${type}`);
      return false;
  }
}

function addSchemaTypes(schemaTypes: Array<string>): string {
  let addedResponse = '';
  const lastSchema = schemaTypes.pop();
  if (schemaTypes.length > 1) {
    addedResponse += `${schemaTypes.join(', ')}, and `;
  } else if (schemaTypes.length === 1) {
    addedResponse += `${schemaTypes[0]} and `;
  }
  return `${addedResponse}${lastSchema} schemas`;
}

export function getTeamSchemaAdminSettingsCopy(): string {
  const activeSchemaTypesCreate: Array<string> = ['automation', 'result', 'request'];
  const activeSchemaTypesUpdate: Array<string> = ['request'];
  if (isFeatureEnabled({feature: ProcessesFeature.PROCESSES_ADMIN})) {
    activeSchemaTypesCreate.push('workflow');
    activeSchemaTypesUpdate.push('workflow');
  }
  if (!BenchlingConfig.PERMISSIONS_ENABLE_ASSAY_SCHEMA_PERMISSIONS) {
    activeSchemaTypesUpdate.push('automation', 'result');
  }
  if (activeSchemaTypesCreate.length === activeSchemaTypesUpdate.length) {
    return `Team members can create and update ${addSchemaTypes(activeSchemaTypesCreate)}`;
  }
  return `Team members can create ${addSchemaTypes(
    activeSchemaTypesCreate
  )}; team members can update ${addSchemaTypes(activeSchemaTypesUpdate)}`;
}
